import { TICK_LENGTH } from '@ardoq/graph';
import { BubbleChartAxisProps, TickMarkProps } from './types';
import { AxisLine, AxisTick, AxisTitle, XAxisLabel } from './atoms';
import { memo } from 'react';

const TickMarkX = ({
  transform,
  gridLineLength,
  tickLabel,
  labelOffset,
}: TickMarkProps) => (
  <g transform={transform}>
    <AxisTick y2={gridLineLength} y1={TICK_LENGTH} />
    <XAxisLabel y={labelOffset} dy=".71em">
      {tickLabel}
    </XAxisLabel>
  </g>
);

export const XAxis = memo(
  ({
    title,
    axisTransform,
    axisLinePath,
    tickProps,
    axisTitleProps,
  }: BubbleChartAxisProps) => (
    <g transform={axisTransform}>
      {tickProps.map(props => (
        <TickMarkX key={props.tickLabel} {...props} />
      ))}
      <AxisLine d={axisLinePath} />
      <AxisTitle {...axisTitleProps}>{title}</AxisTitle>
    </g>
  )
);
